import React from 'react'
import { Typography } from '@material-ui/core'

export const Placeholder = props => (
  <Typography
    color='textSecondary'
    className={props.selectProps.classes.placeholder}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
)



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/components/Placeholder/index.js